/**
 * [角色权限设置]
 * @author: Fu Xiaochun
 * @date: 2021-09-13 
 */

import React, { useState, useEffect, useRef } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { Tabs, Button, message, Table, Divider } from 'antd';
import * as apis from '@/apis/permission/permission';
import BtnSet from '../modal/BtnSet';

const { TabPane } = Tabs;

function RolesPermission(props){
    
    const $this = useRef({selectedRowKeys: [], allMenusWithoutBtn: []});
    const [menuList, setMenuList] = useState(null);
    const [system, setSystem] = useState('PLAT');
    const [permissionType, setPermissionType] = useState('MENU');
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [allMenusWithoutBtn, setAllMenusWithoutBtn] = useState([]);
    const [btnModalVisible, setBtnModalVisible] = useState(false);
    const [btnModalParams, setBtnModalParams] = useState({});


    // emplTableType = 0; // 0:全部员工 1: 部门下员工  2：角色下员工  3：未分类员工  4:其它

    // 切换角色，重置列表
    useEffect(()=>{        
        if(props.roleId){
            reset();
            setSystem(props.roleType);
            switch (permissionType){
                case 'MENU':
                    getListMenu(props.roleId, system);
                    break;
                case 'DATA':
                    getSmartDataPermissions(props.roleId);
                    break;
                default:
                    // nothing to do
            }
        }
    }, [props.roleId]);

    const reset = ()=>{
        setMenuList(null);
        setSelectedRowKeys([]);
        setAllMenusWithoutBtn([]);
        $this.current = {selectedRowKeys: [], allMenusWithoutBtn: []};
    };

    // 获取菜单权限列表
    const getListMenu = (roleId, platType)=>{
        apis.getListMenuByRole({roleId, platType}).then(res=>{
            let menuListWithoutBtn = makeMenuList(res.result);
            
            setMenuList(menuListWithoutBtn);
            setSelectedRowKeys([...$this.current.selectedRowKeys]);
            setAllMenusWithoutBtn([...$this.current.allMenusWithoutBtn]);
            $this.current.selectedRowKeys = [];
            
        }).catch(err=>{
            message.error(err.message);
        });
    };

    // 转换菜单列表 初始化排除按钮，设置默认选中项。
    const makeMenuList = (list)=>{
        return list.filter((item) => {
            if(item.menuType == 'BUTTON'){
                return false;
            }

            $this.current.allMenusWithoutBtn.push({ menuId: item.id, readType: item.readType, isChecked: item.isChecked });

            if(item.isChecked == '1'){
                $this.current.selectedRowKeys.push(item.id);
            }
            if (item.children && item.children.length > 0) {
                item.btns = [];
                for (let i = 0; i < item.children.length; i++) {
                    if (item.children[i].menuType == 'BUTTON') {
                        item.btns.push(item.children[i]);
                    }
                }
                item.children = makeMenuList(item.children);
            }
            return true;
        });
    };
        
    // 获取智能调度系统数据权限列表
    const getSmartDataPermissions = (roleId)=>{
        apis.getSmartDataPermissions({roleId}).then(res=>{
            setMenuList(res.result);
            let selectedIds = makeDataPermissionList(res.result);
            setSelectedRowKeys(selectedIds);
            
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const makeDataPermissionList = (list)=>{
        let selectedRows = [];

        function adapter(list){
            list.forEach(v=>{
                if(v.isChecked == '1'){
                    selectedRows.push(v.id);
                }
                if(Array.isArray(v.children) && v.children.length > 0){
                    adapter(v.children);
                }
            });
        }
        adapter(list);
        return selectedRows;
    };

    // 平台系统切换
    const onSystemChange = (val)=>{
        setPermissionType('MENU');
        setSystem(val);
        reset();
        getListMenu(props.roleId, val);
    };

    // 权限类型切换
    const onPermissionTypeChange = (val)=>{
        setPermissionType(val);
        reset();
        switch (val){
            case 'MENU':
                getListMenu(props.roleId, system);
                break;
            case 'DATA':
                getSmartDataPermissions(props.roleId);
                break;
            default:
                // nothing to do
        }
    };

    const getBtns = (listMenu)=>{

        let buttons = [];

        function filterBtns(list){
            list.forEach((item) => {
                if (item.menuType == 'BUTTON' && item.readType != '') {
                    buttons.push({ menuId: item.id, readType: item.readType });
                } else {
                    if (item.btns && item.btns.length > 0) {
                        filterBtns(item.btns);
                    }
                    if (item.children && item.children.length > 0) {
                        filterBtns(item.children);
                    }
                }
            });
        }

        filterBtns(listMenu);

        return buttons;
    };

    const onSavePermission = ()=>{
        switch (permissionType){
            case 'MENU':
                updateMenuPower();
                break;
            case 'DATA':
                updateDataPower();
                break;
            default:
                // nothing to do
        }
    };

    // 保存菜单权限设置
    const updateMenuPower = () => {
        
        const { roleId } = props;
        let menuIds = [];
        for (let i = 0; i < selectedRowKeys.length; i++) {
            for (let m = 0; m < allMenusWithoutBtn.length; m++) {
                if (selectedRowKeys[i] == allMenusWithoutBtn[m].menuId) {
                    menuIds.push({ menuId: allMenusWithoutBtn[m].menuId, readType: 'READ_WRITE' });
                    break;
                }
            }
        }

        const btns = getBtns(menuList);
        menuIds = menuIds.concat(btns);

        apis.saveRoleMenuList({roleId, platType: system, menuIds}).then(() => {
            message.success('设置成功！');
            // getListMenu(roleId, system);
        }).catch((e) => {
            message.error(e.message);
        });
    };

    const updateDataPower = ()=>{
        const { roleId } = props;
        const authIds = selectedRowKeys;
        const platType = system;

        apis.saveSmartDataPermissions({roleId, authIds, platType}).then(res=>{
            message.success('设置成功！');
            // getSmartDataPermissions(roleId);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const renderHandle = (key, item)=>{
        let hasBtn = false;
        if (item.btns && item.btns.length > 0) {
            for (let i = 0; i < item.btns.length; i++) {
                if (item.btns[i].menuType == 'BUTTON') {
                    hasBtn = true;
                    break;
                }
            }
        }

        return (
            hasBtn ?
                <div className={styles.action}>
                    <div className={styles.item} style={{cursor: 'pointer'}} onClick={() => {
                        setBtnModalVisible(true);
                        setBtnModalParams({...item});
                        // 打开弹窗设置按钮权限
                    }}>设置按钮权限</div>
                </div> : null
        );
    };

    const onBtnModalClose = (status, type, data)=>{
        if(status){
            let list = _resetDataSourceFromBtns(menuList, data);
            setMenuList(list);
        }
        setBtnModalVisible(false);
        setBtnModalParams({});
        
    };

    // 改变dataSource按钮权限
    const _resetDataSourceFromBtns = (list, data) => {
        return list.map((item) => {
            if (item.id == data.id) {
                item = { ...data, btns: _deepCopy(data.btns) };
            } else {
                if (item.children && Array.isArray(item.children) && item.children.length > 0) {
                    item.children = _resetDataSourceFromBtns(item.children, data);
                }
            }
            return item;
        });
    };

    const _deepCopy = (obj) => {
        if (typeof obj !== 'object') {
            return obj;
        }
        var res = Array.isArray(obj) ? [] : {};
        for (let i in obj) {
            if (i == 'component') {
                res[i] = obj[i];
            } else {
                res[i] = _deepCopy(obj[i]);
            }
        }
        return res;
    };

    // 表格复选输入
	const _rowSelection = {
        selectedRowKeys: selectedRowKeys,
		onChange: (selectedRowKeys) => {
            setSelectedRowKeys(selectedRowKeys);
		},
        onSelect: (record, selected, selectedRows) => {
            // console.log(record, selected, selectedRows);
            let ids = selectedRows.map(v=>v.id);
            setSelectedRowKeys(ids);
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
            // console.log(selected, selectedRows, changeRows);
            let ids = selectedRows.map(v=>v.id);
            setSelectedRowKeys(ids);
        },
	};


    // 菜单权限表格列
    const menuColumns = [
        {
            title: '菜单名称',
            dataIndex: 'menuName',
            key: 'menuName',
            width: '80%',
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            width: '20%',
            render: renderHandle
        },
    ];

    // 数据权限表格列
    const dataColumns = [
        {
            title: '数据权限名称',
            dataIndex: 'dataAuthorityName',
            key: 'dataAuthorityName',
        }
    ];

    const columnsConfig = {
        'MENU': menuColumns,
        'DATA': dataColumns
    };

    return (
        <div>
            {[1,2,4].includes(props.emplTableType) && props.isReadWrite == 1 ? (
                <>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <p className={styles.smallHeader}>预设<span style={{ color: '#3094FB', fontWeight: 'bold' }}> {props.roleName} </span>拥有的权限</p>
                        <Button type="primary" style={{ width: '80px', marginLeft: '20px' }} onClick={onSavePermission}>设置</Button>
                    </div>
                    <Divider style={{margin: '10px 0'}} />
                    <Tabs defaultActiveKey={system} onChange={onSystemChange}>
                        {props.roleType == 'OPERATION' ? <TabPane tab="运营后台" key="OPERATION"></TabPane> : <TabPane tab="总控后台" key="PLAT"></TabPane>}
                        <TabPane tab="智能调度系统" key="SMART_PLATFORM"></TabPane>
                    </Tabs>
                    {system == 'SMART_PLATFORM' ? (
                        <Tabs defaultActiveKey={permissionType} onChange={onPermissionTypeChange}>
                            <TabPane tab="菜单权限" key="MENU"></TabPane>
                            <TabPane tab="数据权限" key="DATA"></TabPane>
                        </Tabs>
                    ) : null}
                    <Divider style={{margin: '10px 0'}} />
                    {menuList ? menuList.length ? (
                        <Table
                            expandable={{defaultExpandAllRows: permissionType == 'MENU'}}
                            rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                            rowKey={(record) => record.id}
                            columns={columnsConfig[permissionType]}
                            rowSelection={{..._rowSelection, checkStrictly: permissionType == 'MENU'}}
                            dataSource={menuList}
                            pagination={false}
                        />
                    ) : '无可用权限数据' : null}
                    
                </>
            ) : <p className={styles.smallHeader}>无权限修改该角色的菜单权限</p>}
            {btnModalVisible ? <BtnSet title={`设置“${btnModalParams.menuName}”按钮权限`} closeMode={onBtnModalClose} data={btnModalParams} /> : null}
        </div>
    );
}

RolesPermission.propTypes = {
    roleId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    roleName: PropTypes.string,
    roleType: PropTypes.string,
    isReadWrite: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    isAdmin: PropTypes.number,
    emplTableType: PropTypes.number,
    
};

export default RolesPermission;